import z from 'zod';

import {
  createdByServiceUuid,
  nullableCreatedByUserUuid,
  timestamps,
  uuid,
} from '../common';
import { alphaQuoteEvaluationStatusSchema } from '../enums';

export const base = {
  uuid,

  evaluationStatus: alphaQuoteEvaluationStatusSchema,

  alphaQuoteLineUuid: uuid,
  snapQuotePriceUuid: uuid.nullish(),

  ...nullableCreatedByUserUuid,
  ...createdByServiceUuid,
  ...timestamps,
};

export const alphaQuotePriceBaseSchema = z.object(base);

export type AlphaQuotePriceBase = z.output<typeof alphaQuotePriceBaseSchema>;
